import {
  Button,
  Select,
  Option,
  Dialog,
  Pagination,
  MessageBox,
  Message,
  Form,
  FormItem,
  Step,
  Steps,
  Checkbox,
  Input
} from 'element-ui'

function install (Vue) {
  if (install.installed) {
    return
  }
  Vue.component(Button.name, Button)
  Vue.component(Select.name, Select)
  Vue.component(Option.name, Option)
  Vue.component(Pagination.name, Pagination)
  Vue.component(Dialog.name, Dialog)
  Vue.component(Form.name, Form)
  Vue.component(Steps.name, Steps)
  Vue.component(Step.name, Step)
  Vue.component(FormItem.name, FormItem)
  Vue.component(Input.name, Input)
  Vue.component(Checkbox.name, Checkbox)
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$message = Message
}
export default install



// WEBPACK FOOTER //
// ./src/config/element-index.js